// 在 utils/index.js 或者直接在组件中添加以下方法
export const formatTimeAgo =(dateString) =>{
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date; // 时间差（毫秒）

    // 转换为秒
    const seconds = Math.floor(diff / 1000);

    // 小于 1 分钟
    if (seconds < 60) {
        return '刚刚';
    }

    // 小于 1 小时
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
        return `${minutes}分钟前`;
    }

    // 小于 24 小时
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return `${hours}小时前`;
    }

    // 小于 1 天
    const days = Math.floor(hours / 24);
    if (days < 1) {
        return `${days}天前`;
    }

    // 超过 7 天，显示完整日期
    return dateString.split(' ')[0]; // 只返回日期部分，不包括时间
}